import { useGetSpendingLimitRequest } from '@api/lendingAPI/lapiHooks';
import SpendingLimitView from '../SpendingLimitView/SpendingLimitView';

export function NoPlansView({ creditLimit }: { creditLimit: number | null }) {
    const { spendingLimitRequest, loadingSpendingLimitRequest } =
        useGetSpendingLimitRequest();

    if (loadingSpendingLimitRequest) return null;

    return spendingLimitRequest?.uuid ? (
        <SpendingLimitView creditLimit={creditLimit} />
    ) : null;
}
